export default __webpack_public_path__ + "static/media/plus.4201bf13.svg";